export default __webpack_public_path__ + "static/bed-bath-beyond-7-e-fe5b98d772c6f805d048b40ce1678e97.gif";